; (function ($, window, document, undefined) {
	'use strict';

	var _inputSelector = '.date-picker-input';
	var _buttonSelector = '.input-group-button .button';
	var _calendarWrapperSelector = '.date-picker-calendar-wrapper';
	var _calendarSelector = '.date-picker-calendar';

	var pluginName = 'datePicker';
	var defaults = {
		showCalendarOnLoad: false,
		showCalendarOnTextClick: true,
		showCalendarOnTextFocus: false,
		directionUp: false,
		onDateSelected: null,
		onValueChanged: null,
		onCalendarViewChanging: null
	};

	function DatePicker(element, options) {
		this.$element = $(element);
		this.element = element;
		this.settings = $.extend({}, defaults, options);
		this._name = pluginName;

		this.init();
	}

	$.extend(DatePicker.prototype, {
		init: function () {
			var plugin = this;

			var input = plugin.getInput();
			var button = plugin.getButton();

			if (!plugin.settings.onDateSelected) {
				plugin.settings.onDateSelected = function (sender, eventArgs) {
					var selectedDate = eventArgs.get_renderDay().get_date();
					if (selectedDate &&
						selectedDate instanceof Array &&
						selectedDate.length > 2) {
						var date = new Date(selectedDate[0], selectedDate[1] - 1, selectedDate[2]);

						var input = plugin.getAspNetInput();

						input.remove_valueChanged(plugin.settings.onValueChanged);

						input.set_selectedDate(date);
						input.repaint();

						input.add_valueChanged(plugin.settings.onValueChanged);
					}
					plugin._hideCalendar();
				};
			}

			if (!plugin.settings.onValueChanged) {
				plugin.settings.onValueChanged = function (sender, eventArgs) {
					var writtenDate = eventArgs.get_newDate();
					var calendar = plugin.getAspNetCalendar();

					calendar.remove_dateSelected(plugin.settings.onDateSelected);
					calendar.unselectDates(calendar.get_selectedDates());

					if (writtenDate &&
						writtenDate instanceof Date) {
						var date = [writtenDate.getFullYear(), writtenDate.getMonth() + 1, writtenDate.getDate()];

						calendar.selectDate(date);
						calendar.navigateToDate(date);
					}

					calendar.repaint();
					calendar.add_dateSelected(plugin.settings.onDateSelected);
				};
			}

			var aspNetInput = plugin.getAspNetInput();
			aspNetInput.add_valueChanged(plugin.settings.onValueChanged);

			var aspNetCalendar = plugin.getAspNetCalendar();
			aspNetCalendar.add_dateSelected(plugin.settings.onDateSelected);

			if(plugin.settings.showCalendarOnLoad) {
				plugin._showCalendar();
			}

			if (plugin.settings.showCalendarOnTextClick) {
				input.off('click').on('click', function () {
					plugin._showCalendar();
				});
			}

			if (plugin.settings.showCalendarOnTextFocus) {
				input.off('focus').on('focus', function () {
					plugin._showCalendar();
				});
			}

			button.off('click').on('click', function () {
				plugin._toggleCalendar();
			});

			$(document).on('mouseup.' + plugin._name, function (e) {
				var element = plugin.$element;
				if (!element.is(e.target) &&
					element.has(e.target).length === 0) {
					plugin._hideCalendar();
				}
			});
		},
		getInput: function () {
			var plugin = this;
			if (!plugin._input) {
				plugin._input = $(_inputSelector, plugin.$element);
			}
			return plugin._input;
		},
		getAspNetInput: function () {
			var plugin = this;
			if (!plugin._aspNetInput) {
				var input = plugin.getInput();
				if (input) {
					plugin._aspNetInput = $find(input.attr('id'));
				}
			}
			return plugin._aspNetInput;
		},
		getButton: function () {
			var plugin = this;
			if (!plugin._button) {
				plugin._button = $(_buttonSelector, plugin.$element);
			}
			return plugin._button;
		},
		getCalendarWrapper: function () {
			var plugin = this;
			if (!plugin._calendarWrapper) {
				plugin._calendarWrapper = $(_calendarWrapperSelector, plugin.$element);
			}
			return plugin._calendarWrapper;
		},
		getCalendar: function () {
			var plugin = this;
			if (!plugin._calendar) {
				plugin._calendar = $(_calendarSelector, plugin.$element);
			}
			return plugin._calendar;
		},
		getAspNetCalendar: function () {
			var plugin = this;
			if (!plugin._aspNetCalendar) {
				var calendar = plugin.getCalendar();
				if (calendar) {
					plugin._aspNetCalendar = $find(calendar.attr('id'));
				}
			}
			return plugin._aspNetCalendar;
		},
		_toggleCalendar: function () {
			var plugin = this;
			var cw = plugin.getCalendarWrapper();
			if (cw) {
				var hidden = cw.hasClass('hide');

				if (hidden) {
					plugin._showCalendar();
				} else {
					plugin._hideCalendar();
				}
			}
		},
		_showCalendar: function () {
			var plugin = this;
			var cw = plugin.getCalendarWrapper();

			if (cw) {
				var hidden = cw.hasClass('hide');

				if (hidden) {
					var calendar = plugin.getAspNetCalendar();

					if(!calendar.CurrentViews) {
						var selectedDates = calendar.get_selectedDates();

						if(selectedDates &&
							selectedDates instanceof Array &&
							selectedDates.length > 0) {
							calendar.navigateToDate(selectedDates[0]);
						}
					}

					var input = plugin.getInput();

					if (plugin.settings.directionUp) {
						cw.removeClass('hide')
						  .css('bottom', input.outerHeight())
						  .css('top', 'auto')
						  .css('z-index', 50000);
					} else {
						cw.removeClass('hide')
						  .css('top', input.outerHeight())
						  .css('z-index', 50000);
					}
				}
			}
		},
		_hideCalendar: function () {
			var plugin = this;
			var cw = plugin.getCalendarWrapper();
			if (cw) {
				cw.addClass('hide');
			}
		}
	});

	$.fn[pluginName] = function (options) {
		return this.each(function () {
			if (!$.data(this, 'plugin_' + pluginName)) {
				$.data(this, 'plugin_' + pluginName, new DatePicker(this, options));
			}
		});
	};

	if(!window.initDatePicker) {
		window.initDatePicker = function(trigger, controlId) {
			var control = $('#' + controlId);
			if($.exists(control)) {
				var plugin = control.data('plugin_' + pluginName);
				if(!plugin) {
					control.datePicker(control.data('{0}'));
					plugin = control.data('plugin_' + pluginName);
					plugin._toggleCalendar();
				}
				if(plugin) {
					var tc = $(trigger);
					if(tc) {
						var onClickValue = tc.attr('onclick');
						if(onClickValue.indexOf('initDatePicker(') >= 0) {
							tc.removeAttr('onclick');
						}
					}
				}
			}
		};
	}
}(jQuery, window, document));
